module.exports = __webpack_public_path__ + "img/emoticon-csat-2-on.3080fe50.svg";